import { ApiModule } from '@common/index';
import type { TransactionDataFilter } from '../../transaction-data/models';
import type { PersonHasPaymentSort } from '../relations/person-has-payment/models';

export class ExportApi extends ApiModule {
  protected endpoint = '/export-data';

  public loadAbsolutoriumExportDetails(personIds: any) {
    return this.api.get<Blob>(`${this.endpoint}/absolutorium/xls?personIds=${personIds}`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadEntryContractExportDetails(personIds: any) {
    return this.api.get<Blob>(`${this.endpoint}/entry-contract/xls?personIds=${personIds}`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadTransactionExportDetails(params?: TransactionDataFilter) {
    return this.api.get<Blob>(`${this.endpoint}/transaction/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params
    });
  }

  public loadLoginTransactionExportDetails(params?: TransactionDataFilter) {
    return this.api.get<Blob>(`${this.endpoint}/login-transaction/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob',
      params
    });
  }

  public loadTutorReportExportDetails(personId: number) {
    return this.api.get<Blob>(`${this.endpoint}/tutor-report/xls?personId=${personId}`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public exportPersonHasPayments(personId: number, sort: PersonHasPaymentSort) {
    return this.api.get<Blob>(`${this.endpoint}/payment-export/xls?personId=${personId}&sort=${sort}`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }
}
